<template>
<div>
  <b-container>
    <b-row>
      <b-col md="6">
        <h1>Company</h1>
        
        <b-alert variant="danger" :show="error != ''">{{ error }}</b-alert>
        
        <ValidationObserver v-slot="{ handleSubmit }">
          <b-form @submit.prevent="handleSubmit(save)">
            <b-form-group
              label="Name"
            >
              <ValidationProvider name="Name" rules="required" v-slot="{ errors }">
                <b-form-input v-model="form.name" :state="errors[0] ? false : null"></b-form-input>
                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </b-form-group>

            <b-form-group
              label="Org No."
            >
              <b-form-input v-model="form.orgNo"></b-form-input>
            </b-form-group>

            <b-form-group
              label="Address"
            >
              <b-form-input v-model="form.address"></b-form-input>
            </b-form-group>

            <b-form-row>
              <b-col cols="3">
                <b-form-group
                  label="Post code"
                >
                  <b-form-input v-model="form.postCode"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="City">
                  <b-form-input v-model="form.city"></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>
            
            <b-form-checkbox
              class=mb-3
              v-model="form.isInternal"
            >
              Internal
            </b-form-checkbox>

        <b-card class="my-3" no-body header-bg-variant="primary" header-text-variant="white">
          <template v-slot:header>
            <h4 class="d-inline">Files</h4>
            <div class="float-right">
              <b-btn class="btn-circle" variant="light" @click="openFileDialog"><b-icon-plus></b-icon-plus></b-btn>
            </div>
          </template>
          <b-list-group flush>
            <b-list-group-item class="pb-0">
              <b-row>
                <b-col><strong>Name</strong></b-col>
                <b-col><strong>Added date</strong></b-col>
                <b-col></b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item v-for="(f, i) in form.companyDocs" :key="i">
              <b-row>
                <b-col>{{ f.docTypeName }}</b-col>
                <b-col>{{ f.createdAt.substring(0,10) }}</b-col>
                <b-co>
                  <div class="float-right">
                    <b-button size="sm" variant="outline-secondary" class="mr-2" @click="displayFile(f)">
                      <b-icon-card-text></b-icon-card-text>
                    </b-button>
                    <b-button size="sm" variant="outline-secondary" @click="deleteFile(f.id)"><b-icon-trash></b-icon-trash></b-button>
                  </div>
                </b-co>
              </b-row>
            </b-list-group-item>
          </b-list-group>
        </b-card>
        
        <b-button variant="outline-secondary" class="mr-2" to="/company">Back</b-button>
            <b-button type="submit" variant="primary">Save</b-button>
          </b-form>
        </ValidationObserver>
      </b-col>
    </b-row>

    <AddCompanyFileModal 
      v-model="showFileDialog"
      :doc-types="docTypes"
      @file="uploadFile"
    />
  </b-container>
</div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import AddCompanyFileModal from '../components/AddCompanyFileModal';
import axios from 'axios';

export default {
    components: { ValidationProvider, ValidationObserver, AddCompanyFileModal },
    data() {
      return {
        loadingState: 'loading',
        form: {
          id: 0,
          name: '',
          orgNo: '',
          address: '',
          postCode: '',
          city: '',
          isInternal: false
        },
        error: '',
        files: {},
        showFileDialog: false,
        docTypes: [],
      }
    },
    methods: {
      save() {
        this.error = '';

        axios.put(`/api/companies/${this.$route.params.id}`, this.form)
        .then(() => {
          this.$router.push('/company');
        })
        .catch(() => { 
          this.error = 'Failed to save';
        });
      },
      openFileDialog() {
        this.error = '';
        this.showFileDialog = true;
      },
      deleteFile(id) {
        const index = this.form.companyDocs.findIndex(d => d.id === id);

        if (index > -1) {
          this.form.companyDocs.splice(index, 1);
        }
        
      },
      displayFile(file) {
        if (file.id === 0) {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(this.files[file.fileId]);
          link.download = file.docTypeName;
          link.click();

          URL.revokeObjectURL(link.href);
        } else {
          const link = document.createElement('a');
          link.href = `/api/companydocs/download/${file.id}`;

          link.click();
        }
      },
      uploadFile(form) {
        const fd = new FormData();

        fd.append('file', form.file);

        axios.post('/api/file', fd)
        .then(res => {
          this.form.companyDocs.push({ 
            id: 0,
            docTypeName: form.docTypeName,
            companyId: this.form.id,
            companyDocTypeId: form.companyDocTypeId,
            fileId: res.data
          });
          this.files[res.data] = form.file;
        });
      },
    },
    beforeCreate() {
      const id = this.$route.params.id;
      const companyQuery = axios.get(`/api/companies/${id}`);
      const docTypesQuery = axios.get('/api/companydoctypes')

      Promise.all([companyQuery, docTypesQuery])
      .then(res => {
        this.loadingState = 'done';
        this.form = res[0].data;
        this.docTypes = res[1].data;
      })
      .catch(() => {
        this.error = 'Failed to get company';
      })
    }
}
</script>